import React, { useMemo } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { ChevronUp, ChevronDown } from "lucide-react";
import { mapAudienceToRows } from "../LinkHelper";
import { getCountryName } from "../LinkHelper";

// Custom theme to match your UI
createTheme("fanbaseTheme", {
    text: {
        primary: "#00067e", // dark gray text
        secondary: "#FA6138", // lighter gray text
    },
    background: {
        default: "#ffffff", // white
    },
    context: {
        background: "#FA6138", // orange accent
        text: "#FFFFFF",
    },
    //   divider: {
    //     default: "rgba(31, 41, 55, 0.2)", // subtle gray borders
    //   },
    action: {
        button: "#FA6138",
        hover: "rgba(250, 97, 56, 0.08)",
        disabled: "rgba(0,0,0,.12)",
    },
});

export const CollectedDataTable = ({ audience = [] }) => {
    const data = useMemo(() => mapAudienceToRows(audience), [audience]);

    // Define columns
    const columns = [
        {
            name: <div className="font-bold">Name</div>,
            selector: row => row.name,
            cell: row => (
                <span className="text-theme_clr1 font-semibold">
                    {row.name}
                </span>
            ),
            sortable: true
        },
        {
            name: <div className="font-bold">Email / Profile</div>,
            selector: row => row.email,
            sortable: true,
            width: "280px",
            cell: row => (
                <div className="flex flex-col">
                    {row.email.startsWith("http") ? (
                        <a
                            href={row.email}
                            target="_blank"
                            rel="noreferrer"
                            className="text-theme_clr2 font-bold hover:underline break-all"
                        >
                            View Profile
                        </a>
                    ) : (
                        <span className="text-theme_clr2 font-bold break-all">
                            {row.email}
                        </span>
                    )}
                    <span className="text-xs text-theme_clr1/60 capitalize">
                        {row.service}
                    </span>
                </div>
            )
        },
        {
            name: <div className="font-bold">Country</div>,
            selector: row => row.country,
            cell: row => (
                <span className="text-theme_clr1 font-semibold">
                    {row.country}
                </span>
            ),
            width: "100px"
        },
        {
            name: <div className="font-bold">Added</div>,
            selector: row => row.date,
            sortable: true,
            cell: row => (
                <span className="text-theme_clr1 font-semibold">
                    {new Date(row.date).toLocaleDateString()}
                </span>
            )
        },
    ];

    // Custom table styling
    const customStyles = {
        rows: {
            style: {
                minHeight: "56px",
                // border: '1px solid #FA6138',
                "&:hover": {
                    backgroundColor: "#FFF7F3", // light orange hover
                },
            },
        },
        headCells: {
            style: {
                paddingLeft: "8px",
                paddingRight: "8px",
                borderBottom: "1px solid #FA6138",
                fontWeight: "600",
                fontSize: "14px",
                color: "#00067e", // orange headers
                backgroundColor: "#FFF",
                // borderBottom: "1px solid rgba(31,41,55,0.2)",
            },
        },
        cells: {
            style: {
                paddingLeft: "8px",
                paddingRight: "8px",
                color: "#00067e",
                fontSize: "14px",
                borderBottom: "1px solid #FA6138",
            },
        },
    };

    return (
        <>
            <div className="bg-white rounded-lg border border-b-0 border-theme_clr2">
            <DataTable
                columns={columns}
                data={data}
                theme="fanbaseTheme"
                customStyles={customStyles}
                defaultSortAsc={false}
                pagination
                paginationPerPage={10}                 // default 10
                paginationRowsPerPageOptions={[10, 25, 50]}
                paginationComponentOptions={{
                    rowsPerPageText: "Rows per page:",
                    rangeSeparatorText: "of",
                }}
            />
            </div>
        </>
    );
};

